import { Component, Vue } from 'vue-property-decorator'
import LineSp1Sp2 from './LineSp1Sp2.vue'
import LineSp123 from './LineSp123.vue'
@Component({
  components: {
    LineSp1Sp2,
    LineSp123
  }
})

export default class MainComp extends Vue {
  col1u2 = [
    { s1: 'Wohnort', s2: 'Teufenbachstr. 8, 8810 Horgen' },
    { s1: 'Telefon', s2: '+41 76 737 2811 ' },
    { s1: 'Email', s2: 'hak@hakpat.com ' },
    { s1: 'Zivilstand', s2: 'geschieden' },
    { s1: 'Kinder', s2: 'zwei (Rasmus *2004, Mark *2006)' },
    { s1: 'Nationalität', s2: 'Deutsch (Ausweis C, Einbürgerung beantragt)' }
  ]

  colLine123 = [

    {
      d: '03/2016 – Heute',
      b: 'Angestellt / Dialog AG',
      t: 'Übernahme eingekaufter Software zu Finanzbuchhaltung. ' +
        'Die Software lag als eine „C++ Visual 2010 MFC“ Umgebung vor, die ' +
        '750.000 Zeilen Code umfassend war.Diese waren in eine einzigen EXE Datei gebunden. ' +
        'Konzeption und Umsetzung der Aufteilung in testbaren Modulen und ' +
        'einfügen von Schnittstellen damit die Weiterentwicklung in CSharp erfolgen konnte. ' +
        'Zum Darstellen der Daten wird Crystal Reports genutzt. ' +
        'Mittlerweile wird das ganze Projekt neu in Angular entwickelt.'
    },
    {
      d: '07/2013 – 03/2015',
      b: 'Externer / Leica Geosystems',
      t: 'Weiterentwicklung einer Scanner Software Client Server Architektur ' +
        '(C# 4.5,WCF, WPF, Entity Framework).Client Windows Desktop, Server Windows ' +
        'Embedded Laser Scanner. Scrum wurde strikt angewendet. Jede neue Entwicklung ' +
        'wurde gegen Pattern geprüft und Objektorientier implementiert. Im Team war ich der WPF ' +
        'experte zum einen und für „development Rules“ zuständig um die transparent zu verbessern ' +
        'um insbesondere die Einarbeitung von neuen Leuten zu erleichtern.'
    },
    {
      d: '02/2013 – 05/2013',
      b: 'Externer / SOWI INFORMATIK, Kerns OW',
      t: 'Aufteilung einer VB.NET Applikation in einen Client und Server mittels WCF und Teilmodulen in C#.'
    },
    {
      d: '08/2009 – 11/2012',
      b: 'Angestellt / StratXX - Near Space Technology Software Architekt .net / C#',
      t: 'Architektur und Implementierung einer Ground Control Software in C# für ein autonomes ' +
        'stationäres Luftschiff. Die Architektur des Programms ist so aufgebaut, dass eine Vielzahl ' +
        'von Quellen (Sensoren) parallel und in Echtzeit eingelesen und über ein Messagingsystem verarbeitet ' +
        'werden. Mit Hilfe von WPF werden die Daten übersichtlich und flexibel dargestellt.'
    },
    {
      d: '08/2008 – 08/2009',
      b: 'Angestellt / Landis + Gyr AG, Zug Software Engineer C++, C#',
      t: 'Umstellung der Entwicklungsumgebung von Visual Studio 6 C++ auf Visual Studio 2008 C++ und ' +
        'teilweise C#. Einführen von Richtlinien und insbesondere deren Umsetzung in die Praxis durch ' +
        'Schulungen und Workshops mit den Entwicklern. Überprüfung der Ziele der Umstellung, wie Verringerung ' +
        'von Flüchtigkeitsfehlern und schnellere Umsetzung von Reviews auf Basis von allgemein gültigen und ' +
        'akzeptierten Regeln.'
    },
    {
      d: '01/2002 – 07/2008',
      b: 'Angestellt / DB Systel, Frankfurt Berater und Software Entwickler',
      t: 'Teilprojektleitung, Softwareentwicklung, Schnittstellen- und Datenbankprogrammierung. ' +
        'Visualisierung von Daten zur Optimierung von Zugläufen.In diesem Projekt wurden große Datenmengen ' +
        'von Simulationen über das Reiseverhalten der Passagiere produziert.Ein Ziel des Projektes war es, ' +
        'die Hauptunterschiede in den Simulationsergebnissen zu identifizieren(z.B.Simulation einer Neubaustrecke). ' +
        'Die Visualisierung geschah hauptsächlich in Form von klar strukturierten MS Excel- Tabellen und Grafiken. ' +
        'Weiterentwicklung einer Software zur Berechnung des besten Wegs eines verspäteten Zuges, um pünktlich ' +
        'und mit minimalem Energieaufwand sein Ziel zu erreichen unter Berücksichtigung aller ' +
        'Echtzeit - Parameter(Streckensteigung, Wetterlage, Bremsvermögen, Gesamtgewicht, gesetzliche Vorgaben). ' +
        'Übernahme eine Teilprojektleitung in der die Vorteile von C# im Vergleich zur Entwicklung mit C++ ' +
        'untersucht wurde, dabei war es meine Aufgabe das C# Team von 4 Personen zu leiten. ' +
        'Projekt zur Neugestaltung der Programmierrichtlinien, um den neuen Ansätzen der Objektorientierung ' +
        'in der SAP - ABAP - Sprache Rechnung zu tragen. ' +
        'Umgebung: Windows 3.11, 95, NT 4.0, 2000, Server 2003, Vista; ' +
        'UNIX / Linux / Solaris; Oracle 8 – 10; Crystal Reports; ASP'
    },
    {
      d: '01/2000 – 12/2001',
      b: 'Angestellt / Zentrum für integrierte Verkehrssysteme, Darmstadt Entwickler',
      t: 'Softwareentwicklung, Schnittstellen- und Datenbankprogrammierung. ' +
        'Unter anderem Entwicklung einer Access Datenbank für die Simulation des Verkehrsflusses im Rhein- Main ' +
        '- Gebiet für die Bewerbung der Region um die Ausrichtung der Olympischen Spiele'
    },
    {
      d: '1999 - 2000',
      b: 'Angestellt / HiCad, Darmstadt Software Entwickler',
      t: 'Programmieren von Datenbankanwendungen unter VB'
    },
    {
      d: '1997 - 1998',
      b: 'Externer / Ingenieurbüro Dr. Mertens, Erbach Software Entwickler',
      t: 'Automatische Dokumentenerstellung aufgrund von in Datenbanken abgelegten Textbausteinen'
    },
    {
      d: '1995 - 1997',
      b: 'Bosch, Erbach Software Entwickler',
      t: 'Entwickeln eines Schweißsimulationsprogramms für Volvo, Göteborg'
    },
    {
      d: '1994 - 1995',
      b: 'Merck, Darmstadt',
      t: 'First-level support'
    }
  ]
}
